import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=1b8c4783"
import script from "./CookiesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports